export default class StringMethods {
  public static capitalizeFirstLetter(text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  public static snakeCaseToRegular(text: string) {
    return text.replace(/_/g, ' ');
  }

  public static snakeCaseToCapitalize(text: string) {
    let textArray = text.split('_');
    const exceptions = ['a', 'an', 'the', 'on', 'in', 'for', 'of', 'and'];
    textArray = textArray.map((item) => (exceptions.indexOf(item) === -1 ? this.capitalizeFirstLetter(item) : item));
    return textArray.join(' ');
  }
}
